import React from "react";
import {
  Container,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { projects } from "../../data/projectsData";
import { getImageUrl } from "../../utils";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const ProductDetails = ({}) => {
  const { productId, group } = useParams();

  const productDetails = projects[group].filter((item) => {
    return item.id === productId;
  })[0];

  console.log(productId, group, productDetails);

  const otherProducts = Object.values(projects).flatMap((group, index) =>
    group.map((item) => {
      console.log(index);
      return { ...item, group: `${index + 1}` };
    })
  );

  return (
    <Container>
      <Grid marginTop={3} container spacing={10}>
        {/* Image */}
        <Grid item xs={12} md={4}>
          <img
            src={productDetails.imageSrc}
            alt={productDetails.title}
            style={{ maxWidth: "100%" }}
          />
        </Grid>

        {/* Product Details */}
        <Grid item xs={12} md={4}>
          <Typography variant="h4" gutterBottom>
            {productDetails.title}
          </Typography>
          <Typography variant="body1" gutterBottom>
            Weight Available: 25KG 50KG
          </Typography>
          {productDetails.details.map((detail) => {
            return (
              <ul>
                <Typography variant="body1" textAlign={"left"} gutterBottom>
                  {/* {"-> " + detail} */}
                  <li>{detail}</li>
                </Typography>
              </ul>
            );
          })}
        </Grid>

        {/* Other Products */}
        <Grid
          item
          xs={12}
          md={4}
          style={{
            maxWidth: "fit-content",
            marginLeft: "4rem",
          }}
        >
          <Typography variant="h6" gutterBottom>
            Products Catalogue
          </Typography>
          <List>
            {otherProducts.map((product) => {
              console.log(
                "group" + product.group,
                product.id,
                productId,
                group
              );
              return (
                <ListItem
                  key={product.id}
                  component={Link}
                  to={`/products/group${product.group}/${product.id}`}
                  style={{
                    borderBottom: "1px lightgray dotted",
                    color: "black",
                    ...("group" + product.group === group &&
                      product.id === productId && {
                        backgroundColor: "#4caf50",
                        color: "white",
                        borderRadius: "1rem",
                      }),
                  }}
                >
                  <ListItemIcon>
                    <ArrowForwardIcon />
                  </ListItemIcon>
                  <ListItemText
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      paddingRight: "40px",
                    }}
                    primary={product.title}
                  />
                </ListItem>
              );
            })}
          </List>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ProductDetails;
